export default function Form({ children, handleSubmit, ...rest }) {
  return (
    <form onSubmit={handleSubmit} {...rest}>
      {children}
    </form>
  );
}
